import React from 'react';
import SortableContainer from '../SortableContainer';

export default function FormDesigner(props: any) {
  return <SortableContainer />;
}
